require( './bootstrap' );

// add lazy-load supported
const images = document.querySelectorAll("img");
for (let i = 0; i < images.length; ++i) {
    let original_image_src = images[i].src;
    if (!images[i].classList.contains('lazy') && !images[i].classList.contains('no-lazy')) {
        images[i].src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
        images[i].setAttribute('data-src', original_image_src);
        images[i].classList.add('lazy');
    }
}
import LazyLoad from "vanilla-lazyload";
let myLazyLoad = new LazyLoad();

if (document.querySelector('.casino-list')) {

    let casinoRewievs = Array.from(document.querySelectorAll('.casino-review.display_none'));
    let countersCasino = Array.from(document.querySelectorAll('.title-casino-count-inset div'));
    let count5 = document.querySelector('.casino_count_5');
    let count10 = document.querySelector('.casino_count_10');
    let count15 = document.querySelector('.casino_count_15');
    let count20 = document.querySelector('.casino_count_20');
    let moreBtn = document.querySelector('.casino-list-more a');

    function deleteDisplayNone(numberOrTables) {
        let casinoRewievs2 = Array.from(document.querySelectorAll('.casino-review.display_none'));
        for (let i = 0; i < numberOrTables; i++) {
            if (casinoRewievs2[i]) {
                casinoRewievs2[i].classList.remove('display_none');
            } else {
                break;
            }
        }
        let casinoRewievs3 = Array.from(document.querySelectorAll('.casino-review.display_none'));

        if (moreBtn && !casinoRewievs3.length) {
            moreBtn.classList.add('display_none');
        }
    }

    function displayCounterSwitcher(numberOrTables) {
        let casinoRewievs2 = Array.from(document.querySelectorAll('.casino-review'));
        for (let i = 0; i < casinoRewievs2.length; i++) {
            if (i < numberOrTables) {
                casinoRewievs2[i].classList.remove('display_none');
            } else {
                casinoRewievs2[i].classList.add('display_none');
            }
        }

        if (casinoRewievs2.length > numberOrTables) {
            if(moreBtn) {
                moreBtn.classList.remove('display_none');
            }
        } else {
            if(moreBtn) {
                moreBtn.classList.add( 'display_none' );
            }
        }
    }

    function activeCounter(variable) {
        for (let i = 0; i < countersCasino.length; i++) {
            countersCasino[i].classList.remove('count_active');
        }
        variable.classList.add('count_active');
    }

    deleteDisplayNone(5, casinoRewievs);
    if(moreBtn) {
        moreBtn.onclick = function ( elem ) {
            elem.preventDefault();
            deleteDisplayNone( 5 );
        };
    }

    if(count5) {
        count5.onclick = function () {
            activeCounter( count5 );
            displayCounterSwitcher( 5 );
        };
    }
    if(count10) {
        count10.onclick = function () {
            activeCounter( count10 );
            displayCounterSwitcher( 10 );
        };
    }
    if(count15) {
        count15.onclick = function () {
            activeCounter( count15 );
            displayCounterSwitcher( 15 );
        };
    }
    if(count20) {
        count20.onclick = function () {
            activeCounter( count20 );
            displayCounterSwitcher( 20 );
        };
    }
}


// burger

let buttonMenu = document.querySelector('.burger'),
    menuAdapt = document.querySelector(".header-menu");
if (buttonMenu) adaptiveMenu();

function adaptiveMenu() {
    buttonMenu.addEventListener('click', function () {
        buttonMenu.classList.toggle('burger_active');
        menuAdapt.classList.toggle('menu_open');
    });
}


// SCROLL TO TOP JS

let body = document.body,
    up_button = document.querySelector('.js_up_btn');

if (up_button) {
    window.onscroll = function () {
        checkScroll(up_button);
    };
    checkScroll(up_button);
    up_button.addEventListener('click', scrollToTop);
}

function checkScroll(up_button) {
    let scrolled = window.pageYOffset || document.documentElement.scrollTop,
        h = window.innerHeight;
    if (scrolled > 0.5 * h) {
        up_button.classList.add('active');
    } else {
        up_button.classList.remove('active');
    }
}

function scrollToTop() {
    let start = Date.now();
    let timer = setInterval(function () {
        let timePassed = Date.now() - start;
        let time = 5000;
        let scrolled = window.pageYOffset || document.documentElement.scrollTop;
        if (timePassed >= time || scrolled <= 0) {
            clearInterval(timer);
            return;
        }
        up(timePassed, time, scrolled);
    }, 10);

    function up(timePassed, time, scrolled) {
        if (scrolled > 0) {
            let x = scrolled - (scrolled * timePassed / (2 * time));
            window.scrollTo(0, x);
        }
    }
}

// language switcher
let langBtn = document.querySelector('.language_switcher'),
    langMenu = document.querySelector(".language_switcher_inset");
if (langBtn) selectLang();

function selectLang() {
    langBtn.addEventListener('click', function () {
        langMenu.classList.toggle('lang_menu_open');
    });
}
